
import habo from 'habo';

let flag = false;
const startTime = 0;
const endTime = 0;

export const reportPerformance = (extra = {}) => {
    if (flag) {
        return;
    }
    const fr = endTime - startTime;
    if (!extra.fr && fr) {
        extra.fr = fr;
    }
    try {
        const start = window.performance.timing.navigationStart;
        const end = Date.now();
        habo.perf({
            fsp: end - start,
            ...extra
        });
        flag = true;
    }
    catch (e) {
        console.error(e);
    }
};
